import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { MouseEvent } from "react";

import { useSidebarContext } from "@/components/General/Sidebar/context/sidebar.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const Trigger = ({ className }: Props) => {
    const { t } = useGranite();

    const { assortimentOpen, setAssortimentOpen } = useSidebarContext();

    const handleOnAssortimentClick = (event: MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();

        setAssortimentOpen((prev) => !prev);
    };

    return (
        <Button
            color={"link"}
            fullWidth={true}
            onClick={handleOnAssortimentClick}
            className={cn(
                "tw:px-4 tw:py-2 tw:bg-grey tw:border tw:border-grey-light tw:flex tw:justify-between tw:items-center tw:group tw:text-information tw:transition-colors tw:no-underline! tw:rounded-none!",
                "tw:hover:bg-grey-input",
                className
            )}
        >
            <span className={cn("tw:group-hover:underline")}>
                {t("sideBar.link.productRange")}
            </span>
            <i
                className={cn(
                    "las la-angle-down",
                    "tw:transition-transform tw:no-underline",
                    {
                        "tw:rotate-180": assortimentOpen
                    }
                )}
            />
        </Button>
    );
};
